export const parseArray = (value: string | undefined) => {
  if (!value) {
    return undefined;
  }
  return value.split(',').filter(Boolean);
};
